<template>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div
      v-for="itemData in effectiveItems"
      :key="itemData.item.id"
      :class="['sf-audit-log__item', hideSessionClass, 'tw-px-6']"
    >
      <component
        :is="itemData.is"
        :data-kind="itemData.item.kind"
        :prevent-bubble-unlink="true"
        v-bind="itemData.item"
        :data-testid="itemData.testId"
      ></component>
    </div>
  </div>
</template>

<script>
import AuditLogItem from './audit-log-item'
import AuditLogGroup from './audit-log-group'
import ChangesSinceLastVisitLine from './changes-since-last-visit-line'
import CheckCardWrapped from '@app/application/communication/sections/communication/components/checks/check-card-wrapped'
import useRedactSessionRecording from '@app/shared/vue/composables/use-hide-session-recording'
import RemarkCard from '@app/shared/vue/components/molecules/remark/remark-card.vue'

export default {
  components: {
    ChangesSinceLastVisitLine,
    RemarkCard,
    AuditLogItem,
    AuditLogGroup,
    CheckCardWrapped,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const hideSessionClass = useRedactSessionRecording()

    return {
      hideSessionClass,
    }
  },
  computed: {
    effectiveItems() {
      return this.items.map((item) => {
        if (item.kind === 'remark-card') {
          return {
            item: { remark: item },
            is: 'RemarkCard',
            testId: `${item.kind}-${item.id}`,
          }
        }
        return {
          item,
          is: item.kind,
          testId: `${item.kind}-${item.id}`,
        }
      })
    },
  },
}
</script>

<style lang="scss">
.sf-audit-log__not-reworked .sf-audit-log__item:last-child {
  padding-bottom: 0 !important;
}
</style>
